import { Api } from 'Utils/api';

export interface BulkExportStatus {
  id: number;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  project_count: number;
  error_message: string | null;
  download_url: string | null;
  created_at: string;
  updated_at: string;
}

export async function createBulkExport(startDate: string, endDate: string): Promise<void> {
  await Api.csrfHeader();
  await Api.post('/bulk-exports', {
    start_date: startDate,
    end_date: endDate,
  });
}

export async function getBulkExports(): Promise<BulkExportStatus[]> {
  await Api.csrfHeader();
  const { data } = await Api.get('/bulk-exports');
  return data.data;
}

export async function cancelBulkExport(id: number): Promise<void> {
  await Api.csrfHeader();
  await Api.post(`/bulk-exports/${id}/cancel`);
}
